module.exports = __webpack_public_path__ + "img/aswatson.ca59f879.png";